function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

import { css } from './styled-components';
import identity from 'ramda/src/identity';
import memoizeWith from 'ramda/src/memoizeWith';
export var media = function media(breakpointName) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    return css(["", ";"], function (props) {
      var pixels = props.theme.breakpoints[breakpointName];

      if (pixels === Infinity) {
        return css.apply(void 0, [strings].concat(interpolations));
      }

      return "@media (max-width: ".concat(pixels, "px) {\n                ").concat(css.apply(void 0, [strings].concat(interpolations)), ";\n              }");
    });
  };
};
export var getMediaQuery = function getMediaQuery(breakpoints) {
  return function (breakpointName) {
    if (breakpointName === 'all') {
      return '';
    }

    var px = breakpoints[breakpointName];
    return "@media (max-width: ".concat(px, "px)");
  };
};
export var breakpointGetter = function breakpointGetter(breakpointName, obj) {
  return function (propName) {
    var realPropName = breakpointName === 'all' ? propName : "".concat(breakpointName, "-").concat(propName);
    return obj[realPropName];
  };
};
export var gridGetter = function gridGetter(breakpointName, props) {
  return function (propName) {
    return props.theme.grid[breakpointName][propName];
  };
};
var sortedBreakpoints = memoizeWith(identity, function (breakpoints) {
  return Object.keys(breakpoints).sort(function (a, b) {
    if (breakpoints[a] < breakpoints[b]) {
      return 1;
    }

    if (breakpoints[a] > breakpoints[b]) {
      return -1;
    }

    return 0;
  });
});
export var mapMedia = function mapMedia(mapper) {
  return css(["", ";"], function (props) {
    var mediaQuery = getMediaQuery(props.theme.breakpoints);
    var output = sortedBreakpoints(props.theme.breakpoints).reduce(function (result, key) {
      var newKey = mediaQuery(key);
      var prop = breakpointGetter(key, props);
      var grid = gridGetter(key, props);
      var rules = mapper(prop, grid, props).filter(Boolean);

      if (rules.length > 0) {
        result[newKey] = Object.assign.apply(Object, [{}].concat(_toConsumableArray(rules)));
      }

      return result;
    }, {});
    return output;
  });
};